
  <app-listagem-obras
    title="Obras da Equipe"
    [subtitle]="'(' + totalItems + ')'"
    [descriptionSubtitle]="'Obras atribuídas a todos os usuários da equipe, permitindo uma visão consolidada da carteira.'"
    [data]="obras"
    [pageSize]="pageSize"
    [totalItems]="totalItems"
    [page]="page"
    [responsavel]="responsavel"
    [showFiltroResponsavel]="true"
    (pageChange)="onPageChange($event)"
    (sortChange)="ordenarPor($event.column)"
    (selectionChange)="onSelectionChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (tiposSelecionadosChange)="onTiposObraSelecionadosChange($event)"
    (abrirFichaObra)="abrirDetalhesObra($event)"
    (downloadPdf)="downloadPDFFicha()"
    (imprimir)="impressaoFicha()"
    (abrirEmpresa)="onAbrirEmpresa($event)" 
    [loading]="loadingWorks"
    [selectedRows]="selectedRows"
    (responsavelIdChange)="onResponsavelIdChange($event)"
    (responsavelLimpo)="onResponsavelLimpo()"
    [searchType]="searchType"
    [searchTerm]="searchTerm"
    (searchTypeChange)="onSearchTypeChange($event)"
    (searchTermChange)="onSearchTermChange($event)"
    (searchEnter)="onSearchEnter()"
    [updateInterval]="updateInterval"
    (updateIntervalChange)="onUpdateIntervalChange($event)"
   
  ></app-listagem-obras>
<app-common-loader *ngIf="loadingWorks"></app-common-loader>
